import languageMapping from '../../utils/sf-utils/language-mapping';
import { WindowType } from '../../types/global-window-type';

declare const window: WindowType;

export const updateSFInitConfig = () => {
  window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
  //   window.embeddedservice_bootstrap.settings.devMode = true;

  window.embeddedservice_bootstrap.settings.language = languageMapping(); // For example, enter 'en' or 'en-US'

  // Add NR Log Key
  // Add GA anoynymous id
};
